import React from "react";
import "../pages/Proyect.css";
import sass from "../Assets/iconSkills/sasss.png";
import desing from "../Assets/proyect/desing.png";
import BackButton from "../componets/BackButton";

export const DesingCanvas = () => {
  const handleWebButtonClick = () => {
    window.location.href = "https://653844c27cc8d9089ff6efe5--desing-canvas.netlify.app/";
  };

  const handleGitHubButtonClick = () => {
    window.location.href = "https://github.com/SusanaLab/Maquetacion";
  };

  return (
    <div className="proyect-container">
      <BackButton />
      <div className="proyect-header">
        <h1>Desing Canvas</h1>
    
      <div className="proyect-description">
        <p id="paragraph">
          Design and development of a landing page, based on Venturousgroup's design. The main goal of this project is to put into practice the knowledge acquired throughout various courses, focusing on key aspects such as SASS, flexbox, media queries, keyframes, and the BEM methodology for CSS structure.
        </p>
      </div>
      <div className="proyect-buttons">
        <button className="proyect-button" onClick={handleWebButtonClick}>Web</button>
        <button className="proyect-button" onClick={handleGitHubButtonClick}>GitHub</button>
      </div>
      <div className="proyect-tech">
        <p>Technologies</p>
        <img src={sass} alt="sass" className="computer" />
      </div>  </div>
      <img
        id="new"
        src={desing}
        alt="Learning List"
        className="learning-image"
      />
    </div>
  );
};
